import { Box, Grid, styled } from '@mui/material';
import { Card, Button } from '@totalsoft/rocket-ui';

export const QuotationCard = styled(Card, {
  shouldForwardProp: prop => !['selected', 'disabled', 'isLastModified'].includes(prop)
})(({ theme, selected, disabled, isLastModified }) => ({
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: 'transparent',
  ...(selected && {
    borderColor: theme.palette.primary.main,
    boxShadow: theme.shadows[15]
  }),
  ...(disabled && {
    opacity: 0.7
  }),
  ...(isLastModified && {
    borderStyle: 'dashed',
    borderColor: theme.palette.secondary.main
  })
}));

export const ConventionNameWrapper = styled(Box)(({ theme }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '1',
  lineClamp: '1',
  boxOrient: 'vertical',
  fontWeight: theme.typography.fontWeightBold,
  textAlign: 'right'
}));

export const QuotationTitleWrapper = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  minHeight: '40px'
}));

export const QuotationLoadingTitleWrapper = styled(Grid)(({ theme }) => ({
  paddingBlock: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  '& > div': {
    width: '100%'
  }
}));

export const QuotationButton = styled(Button, {
  shouldForwardProp: prop => !['quotationSelected'].includes(prop)
})(({ theme, quotationSelected }) => ({
  '&.Mui-disabled': {
    backgroundColor: quotationSelected ? theme.palette.secondary.main : theme.palette.primary.main,
    color: theme.palette.common.white,
    opacity: 0.7
  }
}));
